export default __webpack_public_path__ + "static/media/e2d37f34-6bca-473c-b64d-93811f4dc046.c9834c37.woff2";